import { render, staticRenderFns } from "./Elderly.vue?vue&type=template&id=f95d82c0&scoped=true&"
import script from "./Elderly.vue?vue&type=script&lang=js&"
export * from "./Elderly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95d82c0",
  null
  
)

export default component.exports